module.exports = __webpack_public_path__ + "static/media/reactIcon.2bbf54f4.svg";